<template>
  <section :class="$style.list">
    <p>{{ $t("please_get_ready") }}</p>

    <h6>{{ $t("Entity Information") }}</h6>

    <ul>
      <li v-for="(item, index) in $t('ready_list_institution[0]')" :key="index">
        {{ item }}
      </li>
    </ul>

    <h6>{{ $t("Beneficial Owner Information") }}</h6>

    <ul>
      <li v-for="(item, index) in $t('ready_list_institution[1]')" :key="index">
        {{ item }}
      </li>
    </ul>
    <a-button size="large" @click="ready" class="ready_btn">
      {{ $t("ready_to_start") }}
      <a-icon type="right" />
    </a-button>
  </section>
</template>

<script>
import { Button, Icon } from "ant-design-vue";
import { mapActions } from "vuex";

export default {
  name: "Kyc.Institution.List",
  data() {
    return {};
  },
  computed: {},
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon
  },
  methods: {
    ...mapActions("KYC", ["changeApplyType"]),
    ready() {
      const { params } = this.$route;
      const state = "21";
      this.$router.push({
        name: "kyc",
        params,
        query: { ...this.$route.query, state }
      });
    }
  },
  created() {
    this.changeApplyType(1);
  }
};
</script>

<style lang="scss" module>
.list {
  h3 {
    color: $legend-dark-color;
    font-weight: 600;
    margin-bottom: 1.25rem;
    font-size: 1.25rem;
  }
  h6 {
    align-self: flex-start;
    // background-color: $legend-theme-color;
    color: $legend-dark-color;
    font-size: 1rem;
    font-weight: 600;
    margin: 0 0 1rem 7rem;
  }
  p {
    color: $legend-dark-color;
    font-size: 1.125rem;
    font-weight: bold;
    margin-bottom: 3.125rem;
  }
  ul {
    align-self: stretch;
    font-size: 1rem;
    line-height: 1.2;
    list-style: none;
    margin: 0rem 0rem 2rem 3rem;
    padding: 0 4rem;
    li {
      background: url("../../../assets/img/shadowbg/shape-interrupt.svg")
        no-repeat 0rem 3px;
      background-size: 14px 14px;
      text-indent: 2em;
      margin-bottom: 1.2rem;
    }
  }
}
</style>
